import AssignActionForm from "../../components/Forms/AssignActionForm";
import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AssignTrainingForm from "./AssignTrainingForm";


function AssignAction() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AssignActionForm/>
            </BasicCard>
        </>
    )
}
export default AssignAction;